/** Deferred toast shown after onboarding/auth navigation lands. */

export type PostAuthNotice = {
  variant?: "default" | "destructive";
  title: string;
  description: string;
};

const STORAGE_KEY = "kryajet_post_auth_notice";

export const ONBOARDING_PHOTO_UPLOAD_FAILED_NOTICE: PostAuthNotice = {
  variant: "destructive",
  title: "Photo upload failed",
  description:
    "Your account was created, but we could not upload your photo(s). You can add them later from your profile.",
};

export function setPostAuthNotice(notice: PostAuthNotice): void {
  try {
    if (typeof sessionStorage === "undefined") return;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(notice));
  } catch {
    /* private mode / quota */
  }
}

export function consumePostAuthNotice(): PostAuthNotice | null {
  try {
    if (typeof sessionStorage === "undefined") return null;
    const raw = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PostAuthNotice>;
    if (typeof parsed.title !== "string" || typeof parsed.description !== "string") return null;
    return {
      variant: parsed.variant === "destructive" ? "destructive" : "default",
      title: parsed.title,
      description: parsed.description,
    };
  } catch {
    return null;
  }
}
